module.exports = __webpack_public_path__ + "static/wallpaper4-576eaabc2d1c0df2d4cdc7127a9e7626.jpg";